import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth'
import payment from './payment'
import wishlist from './wishlist'
import token from './token'
import gift from './gift'
import user from './user'

import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);
Vue.config.devtools = true

const store = new Vuex.Store({
    modules : {
        auth,
        wishlist,
        token,
        gift,
        user,
        payment
    },
    plugins: [createPersistedState()]
});


export default store;